import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import _ from 'lodash';
import styled from 'styled-components';
import {setFormV2ToasterVisibility} from '../../../actions/toastactions';
import Utility from '../../../util/utilityfunctions';
import ErrorsUtility from './index';
import ToastMessageContainer from '../ToastMessage/ToastMessageContainer';

export default function ModalError({modalLevel}) {
	const errors = useSelector((store) => store.errors),
		isModalOpen = useSelector((store) => store.isModalOpen),
		isADCModalOpen = useSelector((store) => store.isADCModalOpen),
		currentModalLevel = useSelector((store) => store.modalLevel);

	let errorMessage = useRef(null);
	const dispatch = useDispatch();
	const showErrors = isModalOpen && !isADCModalOpen && currentModalLevel === modalLevel;
	const toastMessageFeatureName = 'Modal';

	const addNotification = (level, message, autoDismissInSeconds) => {
		isModalOpen &&
			dispatch(
				setFormV2ToasterVisibility(true, level, Utility.createRichTextElement(message), '', autoDismissInSeconds)
			);
	};

	useEffect(() => {
		if (!_.isEmpty(errors)) {
			if (!_.isEqual(errorMessage.current, errors.message)) {
				errorMessage.current =
					errorMessage.current !== null ? `${errorMessage.current}<br />${errors.message}` : errors.message;
			}
		} else {
			errorMessage.current = null;
		}
		ErrorsUtility.addNotification(errors, addNotification);
	}, [errors]);

	return (
		<StyledModalBanners className="StyledModalBanners StyledModalBannersErrors">
			{showErrors && (
				<ToastMessageContainer
					toastFeature={toastMessageFeatureName}
					className="ModalErrorToastMessageContainer modal-messages-container"
				/>
			)}
		</StyledModalBanners>
	);
}

const StyledModalBanners = styled.section`
	position: absolute;
	width: 100% !important;
	left: 0;
	display: flex;
	flex-direction: column;
	z-index: 9;
	.StyledToastMessageContainer {
		left: var(--spacing-x-large);
	}
	.bannerLabel.InsufficientRightsBannerLabel {
		width: calc(100vw - var(--px-160)) !important;
	}
`;
